<script setup>
import axios  from "axios";
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
<v-dialog
    v-model="corp"
    width="700px"
>
<v-card v-if="corp_detail != null" 
>
<v-toolbar
    tile
    flat
    height="50px"
    color="#E11D31"
    dark
>
<v-toolbar-title><h1>{{ corp_detail.corp_name }}</h1></v-toolbar-title>
<v-spacer />
<v-icon
    @click="corp=false"
>
mdi-close
</v-icon>
</v-toolbar>
<v-card-text
    id="cdial"
>
    <div class="media_op_comp" >
        <a class="media_op_url" :href="corp_detail.site_url" target="_blunk">{{ corp_detail.site_url }}</a>
        <div class="comp_summary_box">
            <ul>
                <li v-if="corp_detail.zip_code != null">&#12306;{{ corp_detail.zip_code }}&nbsp;{{ corp_detail.address }}</li>
                <li v-if="corp_detail.telno != null">&phone;{{ corp_detail.telno }}</li>
                <li v-if="corp_detail.fax != null">fax&nbsp;{{ corp_detail.fax }}</li>    
                <li v-if="corp_detail.mail_address != null">問い合わせメール&nbsp;{{ corp_detail.mail_address }}</li>
                <li v-if="corp_detail.inquiry_url != null">問い合わせフォーム：<a :href="corp_detail.inquiry_url" target="_blunk">{{ corp_detail.inquiry_url }}</a></li>
            </ul>
        </div>
    </div>
   <div class="project-list-table-box">
    <table class="common-table">
     <thead class="common-table__head">
      <tr class="common-table__head-row">
       <th class="common-table__head-title -tx-left">詳細</th>
       <th class="common-table__head-title -status"></th>
      </tr>
     </thead>
     <tbody class="common-table__body" v-cloak>
      <tr class="common-table__body-row"  v-if="corp_detail.name_rep != null">
       <td class="common-table__body-data -tx-left">代表</td>
       <td class="common-table__body-data -nowrap">{{ corp_detail.name_rep }}</td>
      </tr>
      <tr class="common-table__body-row"  v-if="corp_detail.founding_date != null">
       <td class="common-table__body-data -tx-left" >設立</td>
       <td class="common-table__body-data -nowrap">{{ corp_detail.founding_date }}</td>
      </tr>
      <tr class="common-table__body-row"  v-if="corp_detail.capital != null">
       <td class="common-table__body-data -tx-left">資本金</td>
       <td class="common-table__body-data -nowrap">{{ Number(corp_detail.capital).toLocaleString() }}円</td>
      </tr>
      <tr class="common-table__body-row"  v-if="corp_detail.employees != null">
       <td class="common-table__body-data -tx-left">従業員数</td>
       <td class="common-table__body-data -nowrap">{{ Number(corp_detail.employees).toLocaleString() }}人</td>
      </tr>
      <tr class="common-table__body-row"  v-if="corp_detail.parent_company != null">
       <td class="common-table__body-data -tx-left">親会社</td>
       <td class="common-table__body-data -nowrap">{{ corp_detail.parent_company }}</td>
      </tr>
      <tr class="common-table__body-row"  v-if="corp_detail.parent_url != null">
       <td class="common-table__body-data -tx-left">親会社HP</td>
       <td class="common-table__body-data -nowrap">{{ corp_detail.parent_url }}</td>
      </tr>
     </tbody>
    </table>
   </div>
<iframe
frameborder="0" style="border:0;width:100%;height:400px; margin:20px 0 20px 0"
referrerpolicy="no-referrer-when-downgrade"
:src="'https://www.google.com/maps/embed/v1/place?key=AIzaSyCyEVIWSYirqIezj0kDs37_kuz41ApnPC8&q='+encodeURI(corp_detail.address)"
allowfullscreen v-if="corp_detail.zip_code != null">
</iframe>


    <div class="media_tagbox">
       <div class="project-list-table-box" v-if="site_list.length != 0">
        <table class="common-table" >
         <thead class="common-table__head">
          <tr class="common-table__head-row">
           <th class="common-table__head-title -tx-left">運営サイト ({{ site_list.length }}サイト)</th>
           <th class="common-table__head-title -status"></th>
          </tr>
         </thead>
         <tbody class="common-table__body">
          <tr class="common-table__body-row"  v-for="site,index in site_list" :key="index">
           <td class="common-table__body-data -nowrap -tx-left"><a href="javascript:void(0)" v-on:click="mediadsp(site.id)">{{ site.site_name }}</a></td>
           <td class="common-table__body-data -nowrap">{{ site.label }}</td>
          </tr>
         </tbody>
        </table>
       </div>
    </div>
</v-card-text>
</v-card>
</v-dialog>
</template>
<script>
export default {
    data : function(){
        return {
            corp : false,
            corp_detail : null,
            site_list : [],
        };
    },
    methods : {
        mediadsp : function(id){
            this.$emit("mdsp",{id:id});
            this.corp = false;
        },
        get_corp_info : function(id){
            let params = new URLSearchParams();
            this.MediaTitle = '運営会社詳細'
            params.append('op_id',id);

            axios.post("/api/media/get_op_company",params)
            .then(response => {
                this.corp_detail = response.data.op_company[0];
                this.site_list   = response.data.op_site;
                if(this.corp != true)
                    this.corp = true;
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
        open : function(id){
            this.get_corp_info(id);
        },
    },
    updated() {
        const elements = document.getElementsByClassName('v-dialog--active');
        if (!elements || !elements.length) {
          // 要素が取得できなかった場合は終了
          return;
        }
        elements[0].scrollTop = 0;
    },
}
</script>
